module.exports = __webpack_public_path__ + "static/img/507.5e740e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/507.png
// module id = 536
// module chunks = 3